'use strict';

var App = require('app');

var InfoView = Marionette.ItemView.extend({
    template: require('components/account/templates/info'),

    ui: {
        close: '#js-close',
        'show-details': '.js-show-details',
        back: '#js-go-back',
    },

    events: {
        'click @ui.close': 'close',
        'click @ui.show-details': 'showDetails',
        'click @ui.back': 'goBackToMainView',
    },

    serializeData: function () {
        var self = this;
        var data = Marionette.ItemView.prototype.serializeData.apply(this, arguments);

        // select all infos the user wants to see
        data.infos = _.filter(this.getOption('infos'), function (i) {
            return self.getOption('want')[i.id] === true;
        });

        _.each(data.infos, function (i) {
            if (i.id == self.details) {
                data.details = i;
            }
        });

        return data;
    },

    onShow: function () {
        $('#js-modal-dialog .modal-dialog').addClass('modal-lg');
    },

    onDestroy: function () {
        $('#js-modal-dialog .modal-dialog').removeClass('modal-lg');
    },

    close: function () {
        App.hideModal();
    },

    showDetails: function (e) {
        this.details = $(e.currentTarget).attr('id').split('-')[2];
        this.render();
    },

    goBackToMainView: function () {
        this.details = undefined;
        this.render();
    },
});

module.exports = InfoView;
